'use strict';

import is from 'is_js';

export default 'ok!';

/**
 * ==============================
 * 环境判断，无需函数执行
 */
// 在浏览器端
const isInBrowserThis = typeof window !== 'undefined';
// 小写的 userAgent
const useragent = isInBrowserThis && window.navigator.userAgent.toLowerCase();
// 微信
const isWeixinThis = useragent && -1 !== useragent.indexOf('micromessenger');
// 阿里系
const isAliappThis = useragent && -1 !== useragent.indexOf('aliapp');
// 阿里系 - 钉钉
const isDingTalkThis = useragent && -1 !== useragent.indexOf('dingtalk');
// 大风车
const isDafengcheThis = useragent && -1 !== useragent.indexOf('dafengche');
// 大风车 - 车巴巴
// /
// 车牛
const isCheniuThis = useragent && -1 !== useragent.indexOf('cheniu');
// 车牛 - 车行168
// /
// 弹个车
const isTangecheThis = useragent && -1 !== useragent.indexOf('buyerapp');
// 安卓
const isAndroidThis = is.android();
// ios
const isIosThis = is.ios();

/**
 * ==============================
 */

export const phone = input => /^1[0-9]{10}$/.test(input);

export const inBrowser = () => isInBrowserThis;

export const weixin = () => isWeixinThis;

export const aliapp = () => isAliappThis;

export const dingTalk = () => isDingTalkThis;

export const dafengche = () => isDafengcheThis;

export const cheniu = () => isCheniuThis;

export const tangeche = () => isTangecheThis;

export const android = () => isAndroidThis;

export const ios = () => isIosThis;



// WEBPACK FOOTER //
// ./~/@souche-f2e/weidian-util-is/index.babel.js